export default "__VITE_ASSET__Cd$zez_p__"